<template>
    <LoadingComponent :props="loading" />
    <section v-if="loopCategories.length > 0" class="categories-block sm:mb-10">
        <div class="container">
            <h2 class="text-1xl sm:text-2xl font-semibold -mb-10">{{ $t('label.browse_by_categories')}}</h2>
            <Swiper dir="ltr" :speed="500" :loop="loopCategories.length > 1" :loopAdditionalSlides="loopCategories.length"
                :slidesPerGroup="1" :autoplay="autoplayOptions" :navigation="true"
                :modules="modules" class="navigate-swiper" :breakpoints="breakpoints">
                <SwiperSlide v-for="(category, index) in loopCategories" :key="`cat_${category.id}_${index}`" class="mobile:!w-24">
                    <router-link :to="{name: 'frontend.product', query:{ category: category.slug}}"
                                 class="w-full rounded-2xl border group">
                        <img class="w-full block rounded-tl-2xl rounded-tr-2xl" :src="category.thumb" alt="category" >
                        <span class="text-sm sm:text-base font-medium capitalize text-center py-2 px-3 overflow-hidden whitespace-nowrap text-ellipsis block rounded-bl-2xl rounded-br-2xl group-hover:text-primary">
                            {{ category.name }}
                        </span>
                    </router-link>
                </SwiperSlide>
            </Swiper>
        </div>
    </section>
</template>

<script>

import {Navigation, Pagination, Autoplay} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import statusEnum from "../../../enums/modules/statusEnum";
import LoadingComponent from "../components/LoadingComponent";


export default {
    name: "CategoryComponent",
    components: {
        Swiper,
        SwiperSlide,
        LoadingComponent
    },
    setup() {
        return {
            modules: [Navigation, Pagination, Autoplay],
        }
    },
    data() {
        return {
            loading: {
                isActive: false,
            },
            settings: {
                itemsToShow: 6,
                wrapAround: false,
                snapAlign: "start"
            },
            breakpoints: {
                0: {slidesPerView: 'auto', spaceBetween: 16},
                640: {slidesPerView: 4, spaceBetween: 24},
                768: {slidesPerView: 5, spaceBetween: 24},
                1024: {slidesPerView: 6, spaceBetween: 24}
            },
            autoplayOptions: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            }
        }
    },
    computed: {
        categories: function () {
            return this.$store.getters["frontendProductCategory/lists"];
        },
        rootCategories: function () {
            return (this.categories || []).filter((category) => !category.parent_id);
        },
        loopCategories: function () {
            const categories = this.rootCategories || [];
            if (categories.length <= 1) {
                return categories;
            }

            const minLoopItems = 12;
            if (categories.length >= minLoopItems) {
                return categories;
            }

            const multiplier = Math.ceil(minLoopItems / categories.length);
            const repeated = [];
            for (let i = 0; i < multiplier; i++) {
                repeated.push(...categories);
            }

            return repeated;
        }
    },
    mounted() {
        this.loading.isActive = true;
        this.$store.dispatch("frontendProductCategory/lists", {
            paginate: 0,
            order_column: "id",
            order_type: "asc",
            parent_id: null,
            status: statusEnum.ACTIVE,
        }).then(res => {
            this.loading.isActive = false;
        }).catch((err) => {
            this.loading.isActive = false;
        });
    },
}
</script>

